 
import { create, StateCreator } from 'zustand';
import { ProcedureInstanceBase } from '@/backend/models/procedureInstances/procedureInstanceBase';
import { ProcedureInstanceUpdateRequest } from '@/backend/express/controllers/procedureInstanceController';
import { ProcedureInstanceController } from '../controllers/procedureInstanceController';
import { ProcedureInstanceBuilder } from '@/backend/models/procedureInstances/procedureInstanceBuilder';
import { PartDutAssignmentsFrontendController } from '../controllers/partDutAssignmentsFrontendController';

export type ProcedureInstanceStore = {
  procedureInstance: ProcedureInstanceBase | null;
  reset: () => void;
  fetchProcedureInstance: (procedureInstanceId: string) => Promise<void>;
  updateProcedureInstance: (request: ProcedureInstanceUpdateRequest) => Promise<void>;
  createPartDutAssignment: (partId: string, procedureInstanceId: string) => Promise<void>;
  viewProcedureInstance: (procedureInstanceId: string) => Promise<void>;
  exportJson: (procedureInstanceId: string) => Promise<void>;
};

const initialState = {
  procedureInstance: null,
};

export const createProcedureInstanceSlice: StateCreator<ProcedureInstanceStore, [], [], ProcedureInstanceStore> = ((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  fetchProcedureInstance: async (procedureInstanceId) => {
    const response = await new ProcedureInstanceController().read(procedureInstanceId);
    if (response.errors || !response.procedureInstance) {
      return;
    }

    set({ procedureInstance: new ProcedureInstanceBuilder().build(response.procedureInstance) });
  },
  updateProcedureInstance: async (request) => {
    const response = await new ProcedureInstanceController().update(request);
    if (response.errors || response.status !== 200) return;

    set({ procedureInstance: new ProcedureInstanceBuilder().build(response.procedureInstance) });
  },
  // signProcedure: async (procedure, request) => {
  //   const controller = new ProcedureController();
  //   await controller.signProcedure(request);
  //   get().fetchProcedure(procedure.id);
  // },
  viewProcedureInstance: async (procedureInstanceId) => {
    void new ProcedureInstanceController().view(procedureInstanceId);
  },
  exportJson: async (procedureInstanceId) => {
    const response = await new ProcedureInstanceController().exportJson(procedureInstanceId);
    if (response.errors || response.status !== 200) return;

    const blob = new Blob([response.json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${get().procedureInstance?.title}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },
  createPartDutAssignment: async (partId, procedureInstanceId) => {
    try {
      const partDutAssignmentsController = new PartDutAssignmentsFrontendController();
      await partDutAssignmentsController.createPartDutAssignments({
        partId,
        procedureInstanceId,
      });
    } catch (error) {
      console.error('Failed to create partDutAssignments:', error);
      throw error;
    }
  },
  // exportProcedure: async (ipc) => {
  //   const { procedure } = get();
  //   if (!procedure) return;
  //   const controller = new ProcedureIpcController(new ProcedureIpcClient());
  //   const response = await controller.exportProcedure({ procedureId: procedure.id });
  //   if (response.errors && response.errors.length > 0) {
  //     return;
  //   }
  //   ipc.invoke(SHOW_FILE_CHANNEL, { filePath: response.filePath });
  // },
  // setDeviceUnderTestId: async (request: ProcedureUpdateDutRequest) => {
  //   const controller = new ProcedureController();
  //   const response = await controller.setDeviceUnderTestId(request);
  //   if (!response.errors && response.procedure) {
  //     const procedureItem = new ProcedureBuilder().build(response.procedure);
  //     set({ procedure: procedureItem });
  //   }
  // },
  // exportDebugInformation: async (includeRunData) => {
  //   const { procedure } = get();
  //   if (!procedure) return { filePath: '', status: 400 };
  //   const controller = new ProcedureIpcController(new ProcedureIpcClient());
  //   const response = await controller.exportDebugInformation({ procedureId: procedure.id, includeRunData });
  //   return response;
  // },
  // exportProcedureRaw: async (request) => {
  //   await new ProcedureController().exportProcedureRaw(request);
  // },
}));

export const useProcedureInstanceStore = create<ProcedureInstanceStore>(createProcedureInstanceSlice);
